export default __webpack_public_path__ + "static/media/ss9.cd5d9494.jpg";